import React from 'react';
import './Project.css';

import ProjectMediaModal from '../ProjectMediaModal/ProjectMediaModal';

class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.media = this.props.media.map((media, index) => {
        if (media.type === 'image')
          return (
            <img
              key={media.src}
              className="Thumbnail"
              src={process.env.PUBLIC_URL + '/assets/' + this.props.slug + '/thumb/' + media.src + '.png'}
              alt={media.alt}
              title={media.alt}
              onClick={() => this.handleScreenshotClick(index)}
            />
          );
        else if (media.type === 'youtube')
          return (
            <iframe
              key={media.id}
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${media.id}?rel=0`}
              frameBorder="0"
              allowFullScreen
            />
          );

        return null;
      }
    );
  }

  handlePrevClick() {
    if (this.state.modalIndex !== 0)
      this.setState({
        modalIndex: this.state.modalIndex - 1
      });
  }

  handleNextClick() {
    if (this.state.modalIndex !== this.props.media.length - 1)
      this.setState({
        modalIndex: this.state.modalIndex + 1
      });
  }

  handleCloseClick() {
    this.setState({
      showModal: false
    });
  }

  handleScreenshotClick(index) {
    this.setState({
      showModal: true,
      modalIndex: index
    });
  }

  render() {
    return (
      <div className="Project" ref={container => this.container = container}>
        <div className="ProjectHeader">
          <h4>{this.props.name}</h4>
        </div>
        <p className="ProjectDescription">
          {this.props.description}
        </p>
        <div className="ProjectMedia">
          {this.media}
        </div>
        <ProjectMediaModal
          {...this.props}
          showModal={this.state.showModal}
          modalIndex={this.state.modalIndex}
          onPrevClick={() => this.handlePrevClick()}
          onNextClick={() => this.handleNextClick()}
          onCloseClick={() => this.handleCloseClick()}
        />
      </div>
    );
  }

  componentDidMount() {
    if (this.props.match) {
      this.props.changeSection();
      setTimeout(() => {
        this.container.scrollIntoView();
      }, 300);
    }
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project/Project.js